/**
 * @param {Element} $el
 * @param {string} eventName
 * @param {EventListener} listener
 * @param {boolean | EventListenerOptions} [options]
 */
const once = ($el, eventName, listener, options) => {
  /** @type {EventListener} */
  const cb = (event) => {
    listener(event);
    $el.removeEventListener(eventName, cb, options);
  };

  $el.addEventListener(eventName, cb, options);
};


export default once;
